import { React, useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import MainLayout from "../layouts/MainLayout";
import AuthContext from "../contexts/AuthContext";

import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const history = useNavigate();
  const location = useLocation();

  // Get redirect location or provide fallback
  const from = location.state?.from || "/insurrances";
  const auth = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    if (auth.token) {
      history(-1, { replace: true });
    }
  });

  const onSubmit = () => {
    auth.signIn(email, password, () => history(from, { replace: true }));
  };
  return (
    <MainLayout pageCSS="login-page">
      <Row className="justify-content-center login-container">
        <ToastContainer autoClose={5000} />
        <Col lg={6} md={8}>
          <Card className="login-form">
            <Card.Body>
              <h3 className="text-center ">
                <b>{t("login_page_form_header")}</b>
              </h3>

              <Form.Group>
                <Form.Label>
                  {t("login_page_form_input_label_email")}
                </Form.Label>
                <Form.Control
                  label="text"
                  placeholder={t("login_page_form_input_placeholder_email")}
                  value={email}
                  size="lg"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="u-mt-medium">
                <Form.Label>
                  {t("login_page_form_input_label_password")}
                </Form.Label>
                <Form.Control
                  label="password"
                  type="password"
                  placeholder={t("login_page_form_input_placeholder_password")}
                  value={password}
                  size="lg"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <Button
                variant="blue"
                className="login-page-btn-submit u-mt-small "
                onClick={onSubmit}
                // block
                disabled={auth.loading}
              >
                {auth.loading ? (
                  <Spinner
                    variant="standard"
                    as="span"
                    size="sm"
                    role="status"
                    animation="border"
                    aria-hidden="true"
                  />
                ) : (
                  t("login_page_form_login_button")
                )}
              </Button>
              <Link to="/register" className="login-form__redirect-link">
                {t("login_page_form_register_link")}
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </MainLayout>
  );
}

export default Login;
